import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Load translations from static folder
const loadTranslations = async () => {
  try {
    const [enResponse, arResponse] = await Promise.all([
      fetch("/static/ls/json/locales/en.json"),
      fetch("/static/ls/json/locales/ar.json"),
    ]);

    const enTranslation = await enResponse.json();
    const arTranslation = await arResponse.json();

    i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: {
          en: {
            translation: enTranslation,
          },
          ar: {
            translation: arTranslation,
          },
        },
        fallbackLng: "en",
        debug: false,

        interpolation: {
          escapeValue: false,
        },
      });
  } catch (error) {
    console.error("Failed to load translations:", error);
    // Initialize with empty resources as fallback
    i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources: {
          en: { translation: {} },
          ar: { translation: {} },
        },
        fallbackLng: "en",
        debug: false,
        interpolation: {
          escapeValue: false,
        },
      });
  }
};

// Initialize translations
loadTranslations();

export default i18n;
